//vendors
import * as bootstrap from 'bootstrap';
import anime from 'animejs/lib/anime.es.js';
import cookies from 'js-cookie';
require('waypoints/lib/jquery.waypoints.min.js');

window.bootstrap = bootstrap;
window.anime = anime; 
window.Cookies = cookies;